import {OptionProps} from '../../../common/types/components';

const INPUTS = {
    FIRST_NAME: 'firstName',
    SECOND_NAME: 'secondName',
    LAST_NAME: 'lastName',
    SECOND_LAST_NAME: 'secondLastName',
    BIRTH_DATE: 'birthDate',
    DOC_NUMBER: 'docNumber',
    CELL_PHONE: 'cellPhone',
    EMAIL: 'email',
    EMPLOYMENT_VALIDATE_INCOMES: 'employmentInsurances',
    EMPLOYMENT_TYPES: 'employmentTypes',
    EMPLOYMENT_COMPANY_NAME: 'employmentCompanyName',
    EMPLOYMENT_POSITION: 'employmentPosition',
    EMPLOYMENT_START_DATE: 'employmentStartDate',
    EMPLOYMENT_ADDRESS: 'employmentAddress',
    EMPLOYMENT_EXTERNAL_NUMBER: 'employmentExternalNumber',
    EMPLOYMENT_INTERNAL_NUMBER: 'employmentInternalNumber',
    EMPLOYMENT_POSTAL_CODE: 'employmentPostalCode',
    EMPLOYMENT_STATE: 'employmentState',
    EMPLOYMENT_CITY: 'employmentCity',
    EMPLOYMENT_MUNICIPALITY: 'employmentMunicipality',
    EMPLOYMENT_COLONY: 'employmentColony',
    EMPLOYMENT_PHONE: 'employmentPhone',
    EMPLOYMENT_PHONE_EXT: 'employmentPhoneExt',
    EMPLOYMENT_MONTHLY_INCOME: 'employmentMonthlyIncome',
    EMPLOYMENT_BILLING: 'employmentBilling',
    EMPLOYMENT_TAX_REGIME: 'employmentTaxRegime',
    DOMICILE_ADDRESS: 'domicileAddress',
    DOMICILE_EXTERNAL_NUMBER: 'domicileExternalNumber',
    DOMICILE_INTERNAL_NUMBER: 'domicileInternalNumber',
    DOMICILE_POSTAL_CODE: 'domicilePostalCode',
    DOMICILE_STATE: 'domicileState',
    DOMICILE_CITY: 'domicileCity',
    DOMICILE_PHONE: 'domicilePhone',
    HOLDING_RESIDENCE_TITLE_TYPE: 'holdingResidenceTitleType',
    DOMICILE_MONTHLY_RENT: 'domicileMonthlyRent',
    COMPLETE_NAME: 'completeName',
    PHONE: 'phone',
    DESIRED_VEHICLE_YEAR: 'year',
    DESIRED_VEHICLE_BRAND: 'brand',
    DESIRED_VEHICLE_MODEL: 'model',
    DESIRED_VEHICLE_VERSION: 'version',
    DESIRED_VEHICLE_ASSEMBLY_COUNTY: 'assemblyCountry',
    DESIRED_VEHICLE_CHASSIS: 'chassis',
    CREDIT_PRICE: 'price',
    CREDIT_DOWN_PAYMENT: 'downPayment',
    CREDIT_TERM: 'term',
    CREDIT_DISCOUNT: 'discount',
    CREDIT_PROFILE: 'profile',
    OPPENING_COMMISSION: 'opennig_commission',
    CREDIT_CLIENT_TYPE: 'clientType',
    CREDIT_LIN_GPS: 'lifeInsuranceAndGps',
    CREDIT_OUTLAY_DATE: 'outlayDate',
    CREDIT_SIGNATURE_DATE: 'signatureDate',
    INSURANCE_INCLUDE: 'include',
    INSURANCE_AMOUNT: 'amount',
    MONTHLY_GPS: 'monthly_gps',
    DEBT_BALANCE_INSURANCE: 'debt_balance_insurance',
    FINANCING_AMOUNT: 'amount_finance',
    MONTHLY_CAPITAL: 'monthly_capital',
    MONTHLY_INTEREST: 'monthly_interest',
    GPS_SDD: 'gps_sdd',
    MONTHLY_PAYMENT: 'monthly_payment',
    TOTAL_CAPITAL: 'total_capital',
    TOTAL_INTEREST: 'total_interest',
    TOTAL_PAY: 'total_pay',
    COMMISSION_AMOUNT: 'commission_amount',
    INITIAL_PAYMENT: 'initial_payment',
    ANNUAL_RATE: 'annual_rate',
    ANNUAL_RATE_IVA: 'annual_rate_iva',
    MONTHLY_RATE: 'monthly_rate',
    MONTHLY_RATE_IVA: 'monthly_rate_iva',
    AMORTIZATION_TEMPLATE: 'credito-real-amortization',
    INSURANCE_POLICY_NUMBER: 'policyNumber',
    INSURANCE_BITUAJ_FOLIO_COT: 'bituajFolioCot',
    INSURANCE_POLICY_DATE_START: 'policyDateStart',
    INSURANCE_POLICY_DATE_END: 'policyDateEnd',
    INSURANCE_CARRIER: 'carrier',
    INSURANCE_DRIVER: 'driver',
    INSURANCE_AMOUNT_TO_INSURE: 'amountToInsure',
    INSURANCE_NET_PREMIUM_AMOUNT: 'insuranceNetPremiumAmount',
    TRACKING_ADDRESS: 'trackingAddress',
    TRACKING_CONTACT_NAME: 'trackingContactName',
    TRACKING_CONTACT_PHONE: 'trackingContactPhone',
    TRACKING_INSTALLATION_DATE: 'trackingInstallationDate',
    TRACKING_INSTALLATION_STATUS: 'trackingInstallationStatus',
    TRACKING_DEVICE: 'trackingDevice',
    MECHANICAL_INCLUDE: 'mechanicalInclude',
    MECHANICAL_WARRANTY_TYPE: 'mechanicalWarrantyType',
    MECHANICAL_WARRANTY_POLICY_NUMBER: 'mechanicalWarrantyPolicyNumber',
    MECHANICAL_COVERAGE: 'mechanicalCoverage',
    INSURANCE_PAYMENT_OPTIONS: [
        'Financiado',
        'Contado'
    ],
    MILEAGE: 'kilometraje',
    POINT_OF_SALE_NAME: 'posGroupName',
    POINT_OF_SALE_MOTORFY_ID: 'posGroupMotorfyId',
    BANK_ACCOUNT_NAME: 'bankAccount',
    COMMISSION_BANK_ACCOUNT_NAME: 'commissionBankAccount',
    COMMISSION_CARD_ACCOUNT_NAME: 'commissionCardAccount',
    COMMISSION_BANK_ACCOUNT_DATE_REGISTER: 'commissionBankAccountDateRegister',
    COMMISSION_BANK_ACCOUNT_DATE_REGISTER_INPUT: 'commissionBankAccountDateRegisterInput',
    RECORD_STATE: 'state',
    RECORD_DATE_SENT: 'dateSent',
    RECORD_DATE_OWNER_CHANGED: 'dateOwnerChanged',
    RECORD_DATE_DISBURSEMENT_DELAYED: 'dateDisbursementDelayed',
    RECORD_DATE_RECEIVED: 'dateReceived',
    RECORD_COMMENTS: 'comments',
    RECORD_DELIVERY_TIME: 'deliveryTime',
    RECORD_COMPLETE_RECORD_TIME: 'completeRecordTime',
    RECORD_TOTAL_TIME: 'totalTime',
    GIFT_CARD_BENEFICIARY: 'beneficiary',
    GIFT_CARD_AMOUNT: 'amount',
    CURP: 'curp',
    VALIDATION_ID_REENTER_OCR: 'OCR',
    VALIDATION_ID_REENTER_CIC: 'CIC',
    VALIDATION_ID_REENTER_ANIO_REGISTRO: 'AnioDeRegistro',
    VALIDATION_ID_REENTER_FECHA_EMISION: 'Fecha_Emision',
    VALIDATION_ID_REENTER_DUPLICADOS: 'Duplicados',
    VALIDATION_ID_REENTER_CLAVE_ELECTOR: 'Clave_Elector',
    NATIONALITY: 'nationality',
    BIRTH_COUNTRY: 'birthCountry',
    HOUSE_BETWEEN_STREET: 'houseBetweenStreet',
    HOUSE_BETWEEN_STREET_AND: 'houseBetweenStreetAnd',
    ASSEMBLY_COUNTRY: 'assemblyCountry',
    APPROVAL_CONDITIONS_RATE: 'approvalConditionsRate',
    APPROVAL_CONDITIONS_TERM: 'approvalConditionsTerm',
    APPROVAL_CONDITIONS_TERM_OTHER: 'approvalConditionsTermOther',
    APPROVAL_CONDITIONS_INITIAL_DOWN_PAYMENT: 'approvalConditionsInitialDownPayment',
    APPROVAL_CONDITIONS_APPROVED_DOWN_PAYMENT: 'approvalConditionsApprovedDownPayment',
};

const MX_VALUES: DefaultValues = {
    BOOLEAN_VALUES: [{
        id: '1', value: true, label: 'Si'
    }, {
        id: '2', value: false, label: 'No'
    }]
};

export const CONSTANTS_OCCUPATIONS = {
    HOUSEWIFE: 'Housewife',
    STUDENT: 'Student',
    UNEMPLOYED: 'Unemployed'
};

export const LAPSE = {
    YEARS: 'YEARS',
    MONTHS: 'MONTHS'
};

export interface DefaultValues {
    BOOLEAN_VALUES: OptionProps[];
}

export {
    INPUTS,
    MX_VALUES
};
